import { commonTexts, enrollmentTexts } from 'consts/text';
import { AppModal, AppModalProps } from 'components/molecules';
import { ModalButton } from 'components/organisms/AppConfirmModal/AppConfirmModal.styled';
import { AppParagraph } from 'components/atoms';
import { colors } from 'theme/styledComponents/colors';
import { IconHomeMove } from '@tabler/icons-react';

export const EnrollmentMoveChildrenModal = ({
    open,
    onCancel,
}: Pick<AppModalProps, 'open' | 'onCancel'>) => (
    // TODO implement logic for moving children and close the modal when confirmed or rejected
    <AppModal
        onCancel={onCancel}
        // Add margin to title
        icon={<div style={{ height: '30px' }} />}
        width={420}
        open={open}
        title={enrollmentTexts.moveChildren.title}
        footer={
            <>
                <ModalButton onClick={onCancel}>{commonTexts.actionLabels.goBack}</ModalButton>
                <ModalButton icon={<IconHomeMove />} type="primary" onClick={onCancel}>
                    {commonTexts.actionLabels.move}
                </ModalButton>
            </>
        }
        isMobileFullScreenMode={false}
    >
        <AppParagraph
            textType="BodyMedium"
            color={colors.grayscale.gray9}
            margin={0}
            marginLeft={32}
            marginRight={32}
            textAlign="center"
        >
            {enrollmentTexts.moveChildren.message}
        </AppParagraph>
    </AppModal>
);
